export default [
    {
        path: '/upgradeClass/queryFlight', //升舱查航班 
        component: resolve => require(['@/pages/upgradeClass/queryFlight'], resolve),
        meta: { title: "长龙航空" }
    },{
        path: '/upgradeClass/queryForm', //升舱表单 
        component: resolve => require(['@/pages/upgradeClass/queryForm'], resolve),
        meta: { title: "长龙航空" }
    },{
        path: '/upgradeClass/payOrder', //支付页面 
        component: resolve => require(['@/pages/upgradeClass/payOrder'], resolve),
        meta: { title: "长龙航空" }
    },{
        path: '/upgradeClass/submitStatus', //提交状态页 
        component: resolve => require(['@/pages/upgradeClass/submitStatus'], resolve),
        meta: { title: "长龙航空" }
    },{
        path: '/upgradeClass/qrcode', //升舱二维码页 
        component: resolve => require(['@/pages/upgradeClass/qrcode'], resolve),
        meta: { title: "长龙航空" }
    },
]


// WEBPACK FOOTER //
// ./src/router/modules/upgradeClass.js